module.exports = __webpack_public_path__ + "static/media/icon_viber.2ff16059.svg";